import { useSelector } from "react-redux";
import { isAuthInitializing, userInfo } from "../../app/store/authSlice";
import { Navigate } from 'react-router-dom';
import { Box, CircularProgress } from "@mui/material";

const ProtectedRoute = ({ children, allowedRoles }) => {
    const user = useSelector(userInfo);
    const isInitializing = useSelector(isAuthInitializing)

    if (isInitializing) {
        return (
        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
            <CircularProgress />
        </Box>
        );
    }

    if (!user) {
        return <Navigate to="/" replace />;
    }

    if (allowedRoles && !allowedRoles.some((role) => user.groups.includes(role))) {
        return <Navigate to={`/workshop-owner/${user.companyId}`} replace />;
    }

    return children;
};

export default ProtectedRoute